// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13uVU","questions":"styles_questions__3DV-T","footer":"styles_footer__dpSba"};